// import React from 'react';
import React, { useState } from 'react';
import './style/accessDenied.scss';
// import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
// import accessdenied from '../assets/images/accessdenied.svg';
import CustomPlanForm from '../pages/growz/subscription/Plans/forms/CustomPlanForm';
import { useDispatch, useSelector } from 'react-redux';
import successBadge from '../assets/images/success.svg';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import blueTickIcon from '../assets/images/blue-tick.svg';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { _date, _route } from '../utils';
import AgencyLogo from './growz/AgencyLogo';
import Footer from './components/FooterAuth';
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import { SUBSCRIPTION_REQUEST_QUOTE } from '../config/api';
import http from '../config/http';
import { setUserInfoToRedux } from '../components/auth/action';
import { toast } from 'react-toastify';

const useStyles = makeStyles({
  BackButton: {
    display: 'inline-block',
    verticalAlign: 'top',
    color: '#ffffff',
    padding: '6px 10px',
    borderRadius: '6px',
    cursor: 'pointer',
    marginBottom: '0',
    '&:hover': {
      background: 'rgb(255 255 255 / 17%)',
    },
  },
  features: {
    color: 'var(--neutral-800, #170F49)',
    fontSize: '16px',
    fontFamily: 'Inter',
    lineHeight: '28px',
    marginLeft: '12px',
  },
});

const addOns = [
  'Monitor Campaign performance and fix structure.',
  'Launch AutoPilots to increase sales.',
  'Automate your day-to-day bidding & Negative keywords.',
  'Account manager will not be able to optimize your Brand.',
];

function TrialExpired() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { mobile, countryCode, email } = useSelector(({ auth }) => auth.user);
  const { isRequestedQuote } = useSelector(({ auth }) => auth.store);
  const { trialEndsOn } = useSelector(({ auth }) => auth.org);
  const [quoteSubmitted, setQuoteSubmitted] = useState(isRequestedQuote ?? false);

  const goToPreviousPath = (e) => {
    e.preventDefault();
    history.push(_route('stores'));
  };

  const resendRequest = async () => {
    setLoading(true);
    const payload = {
      mobile,
      countryCode,
      email,
      message: 'Requested quote resent again!',
    };
    try {
      await http.post(SUBSCRIPTION_REQUEST_QUOTE, payload);
      await setUserInfoToRedux(dispatch);
      toast.success('Quote resent again successfully');
      setLoading(false);
    } catch (err) {
      toast.error(err.response.data.message);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          maxHeight: '100vh',
          overflowY: 'auto',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '1em 1.4em',
            backgroundColor: '#000000',
            alignItems: 'center',
          }}
        >
          <div className={classes.BackButton} onClick={goToPreviousPath}>
            <ArrowBackIcon style={{ verticalAlign: 'middle', width: '16px', height: '16px', marginRight: '6px' }} />
            <span style={{ verticalAlign: 'middle', fontWeight: '500' }}>Go to All Stores</span>
          </div>
          <AgencyLogo />
          <a
            href="https://calendly.com/product-walkthrough-sellergeni/30min"
            target="_blank"
            rel="noreferrer"
            className={classes.BackButton}
          >
            <span style={{ verticalAlign: 'middle', fontWeight: '500' }}>Contact us</span>
          </a>
        </div>
        <div className="trial_expired_holder">
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: '4em',
              paddingBottom: '4em',
              background: '#ffffff',
              padding: '2rem',
              borderRadius: '8px',
            }}
          >
            <div style={{ width: '56%' }}>
              <div
                style={{
                  color: '#5433FF',
                  fontSize: '14px',
                  fontFamily: 'Inter',
                  fontWeight: 600,
                  lineHeight: '20px',
                }}
              >
                Trial expired on {_date(trialEndsOn, '-', 'DD MMM YYYY')}
              </div>
              <div className="sectionHeadingLg" style={{ color: '#D92D20' }}>
                Trial Expired!
              </div>
              <div
                style={{
                  fontStyle: 'normal',
                  fontWeight: '400',
                  marginTop: '8px',
                  color: 'var(--gray-500, #667085)',
                  fontSize: '16px',
                  fontFamily: 'Inter',
                  lineHeight: '24px',
                  width: '90%',
                }}
              >
                Sorry about that, But your trial has expired now. <br />
                You can upgrade your plan by contacting our support team.
              </div>
              <div>
                <div style={{ margin: '1rem 0' }}>
                  <div style={{ fontWeight: 500, fontSize: '14px', lineHeight: '28px', color: '#101828' }}>
                    You won't be able to,
                  </div>
                  <div style={{ marginBottom: '2rem', marginTop: '0.6rem' }}>
                    {addOns.map((feature) => (
                      <>
                        <div className="flexAlignCenter" style={{ margin: '8px 0' }}>
                          <div style={{ display: 'flex' }}>
                            <img src={blueTickIcon} style={{ height: '20px' }} />
                          </div>
                          <div className={classes.features}>{feature}</div>
                        </div>
                      </>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="cardShadowPrimary"
              style={{
                width: '400px',
                padding: '24px 20px',
                borderRadius: '8px',
                border: '1px solid #EAECF0',
                background: 'var(--base-white, #FFF)',
                boxShadow: '0px 4px 7px 5px rgba(0, 0, 0, 0.04)',
                borderBottom: '3px solid #6447ff',
                marginLeft: '3em',
              }}
            >
              {!quoteSubmitted ? (
                <CustomPlanForm
                  userPrompt="Write a message"
                  btnText="Request Call"
                  quoteSubmitted={(val) => setQuoteSubmitted(val)}
                />
              ) : (
                <>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      height: '400px',
                    }}
                  >
                    <img src={successBadge} />
                    <div
                      style={{
                        color: 'var(--gray-900, #101828)',
                        textAlign: 'center',
                        fontSize: '28px',
                        fontFamily: 'Inter',
                        fontWeight: 600,
                        lineHeight: '28px',
                        margin: '12px 0',
                      }}
                    >
                      Thank you!
                    </div>
                    <div
                      style={{
                        color: 'var(--gray-500, #667085)',
                        textAlign: 'center',
                        fontSize: '14px',
                        fontFamily: 'Inter',
                        lineHeight: '20px',
                      }}
                    >
                      Your submission has been sent, We will get in touch with you shortly.
                    </div>
                    <div
                      onClick={resendRequest}
                      style={{ color: '#5433ff', marginTop: '1rem', fontWeight: 500, cursor: 'pointer' }}
                    >
                      {!loading ? (
                        <>
                          <div className="flexAlignCenter">
                            <ReplayRoundedIcon style={{ width: '18px', marginRight: '6px' }} /> Resend request!
                          </div>
                        </>
                      ) : (
                        <CircularProgress size={20} />
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default TrialExpired;
